import React from 'react';

const privacyLinks = [
  { tag: 'aen', link: '/Privacy-statement-videoconferencing-en.pdf' },
  { tag: 'anl', link: '/Privacy-statement-videoconferencing-nl.pdf' },
];
export const PRIVACY_VALUES = privacyLinks.reduce((acc, row) => ({
  ...acc,
  [row.tag]: (msg) => (
    <a href={row.link} target="_blank" id="privacy-link">
      {msg}
    </a>
  ),
}), {});
